<template>
  <div class="image-upload-field">
    <div class="image-upload-field_label">
      {{ label }}
    </div>

    <upload-image
      :img="value"
      @input="emitInput"
      color="orange"
      label="Загрузить"
    >
      Загрузить фото
    </upload-image>
  </div>
</template>

<script>

  import UploadImage from '@/components/UploadImage.vue'

  export default {
    name: 'ImageUploadField',
    components: { UploadImage },

    props: {
      value: {
        type: String,
        default: null,
      },
      label: {
        type: String,
        default: 'Изображение',
      },
      loading: Boolean,
      disabled: Boolean,
    },
    computed: {

    },
    methods: {
      emitInput (value) {
        this.$emit('input', value)
      },
    },
  }
</script>

<style lang="less" scoped>
.image-upload-field {
  margin-bottom: 30px;
  &_label {
    margin-bottom: 15px;
    font-size: 16px;
  }
}
</style>
